export const CREATE_COMMENT_REQUEST = 'commentReducer/CREATE_COMMENT_REQUEST';
export const CREATE_COMMENT_SUCCESS = 'commentReducer/CREATE_COMMENT_SUCCESS';
export const CREATE_COMMENT_FAILED = 'commentReducer/CREATE_COMMENT_FAILED';
export const CREATE_COMMENT_RESET = 'commentReducer/CREATE_COMMENT_RESET';

export const UPDATE_COMMENT_REQUEST = 'commentReducer/UPDATE_COMMENT_REQUEST';
export const UPDATE_COMMENT_SUCCESS = 'commentReducer/UPDATE_COMMENT_SUCCESS';
export const UPDATE_COMMENT_FAILED = 'commentReducer/UPDATE_COMMENT_FAILED';
export const UPDATE_COMMENT_RESET = 'commentReducer/UPDATE_COMMENT_RESET';

export const DELETE_COMMENT_REQUEST = 'commentReducer/DELETE_COMMENT_REQUEST';
export const DELETE_COMMENT_SUCCESS = 'commentReducer/DELETE_COMMENT_SUCCESS';
export const DELETE_COMMENT_FAILED = 'commentReducer/DELETE_COMMENT_FAILED';
export const DELETE_COMMENT_RESET = 'commentReducer/DELETE_COMMENT_RESET';